import * as React from "react";
import { LeftRightArrow } from "./arrow";

export const ScrollButtons = ({
    fadeLeft,
    fadeRight,
    onClick,
    isBigger
}: {
    fadeLeft: boolean;
    fadeRight: boolean;
    onClick: ({ isLeft }: { isLeft: boolean }) => void;
    isBigger?: boolean;
}) => {
    return (
        <div className="pointer-events-none absolute top-0 left-0 z-10 flex h-full w-full items-center">
            <div className="h-10">
                <ScrollButton
                    isLeft={true}
                    isBigger={isBigger}
                    onClick={onClick}
                    disabled={!fadeLeft}
                ></ScrollButton>
                <ScrollButton
                    isLeft={false}
                    isBigger={isBigger}
                    onClick={onClick}
                    disabled={!fadeRight}
                ></ScrollButton>
            </div>
        </div>
    );
};

const ScrollButton = ({
    isLeft,
    disabled,
    onClick,
    isBigger
}: {
    isLeft: boolean;
    disabled: boolean;
    onClick: ({ isLeft }: { isLeft: boolean }) => void;
    isBigger?: boolean;
}) => {
    return (
        <button
            disabled={disabled}
            onClick={(e) => {
                e.preventDefault();
                onClick({ isLeft: isLeft });
            }}
            className={`pointer-events-auto absolute flex h-10 w-10 items-center justify-center rounded-full bg-zinc-700 transition-opacity duration-300
            ${isLeft ? "left-0" : "right-0"}
            ${disabled ? "opacity-[15%]" : "opacity-100"}
        `}
        >
            <LeftRightArrow className={`text-white`} headingLeft={isLeft} />
        </button>
    );
};
